/* NGC cursor glow: a soft, sparkling light that follows the mouse.
   Drawn on one fixed canvas that sits behind all content, so it "rolls behind"
   buttons and cards. Nearby buttons get a rim-light via --bx/--by/--bglow.
   Mouse users only; off for touch, reduced motion and Save-Data. The animation
   loop sleeps whenever the pointer is idle and nothing is fading. */
(function () {
  'use strict';

  var canvas = document.querySelector('.ngc-cursor-glow');
  if (!canvas) return;
  var conn = navigator.connection;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      (conn && conn.saveData)) {
    canvas.remove();
    return;
  }

  var ctx = canvas.getContext('2d');
  var strength = Math.min(1, Math.max(0.1, (parseInt(canvas.getAttribute('data-strength'), 10) || 50) / 100));
  var rgb = parseColor(canvas.getAttribute('data-color')) || [240, 178, 63];
  var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
  var w = 0, h = 0;

  var target = { x: -999, y: -999 };
  var glow = { x: -999, y: -999 };
  var intensity = 0;      /* 0..1, eases in/out */
  var wantOn = false;
  var particles = [];
  var last = 0, running = false, lastSpawn = { x: 0, y: 0 };
  var buttons = [], btnTick = false;

  function parseColor(c) {
    if (!c) return null;
    c = c.trim();
    var m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(c);
    if (!m) return null;
    var hex = m[1];
    if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
    return [parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16)];
  }
  function rgba(a) { return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + a + ')'; }

  function resize() {
    w = window.innerWidth; h = canvas.clientHeight || window.innerHeight;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function collectButtons() { buttons = Array.prototype.slice.call(document.querySelectorAll('.ngc-btn')); }

  function lightButtons() {
    btnTick = false;
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var r = b.getBoundingClientRect();
      if (r.bottom < -300 || r.top > h + 300) continue;
      var cx = Math.max(r.left, Math.min(target.x, r.right));
      var cy = Math.max(r.top, Math.min(target.y, r.bottom));
      var d = Math.hypot(target.x - cx, target.y - cy);
      var near = wantOn ? Math.max(0, 1 - d / 260) : 0;
      if (near > 0) {
        b.style.setProperty('--bx', (target.x - r.left).toFixed(0) + 'px');
        b.style.setProperty('--by', (target.y - r.top).toFixed(0) + 'px');
        b.style.setProperty('--bglow', (near * (0.5 + strength * 0.5)).toFixed(2));
        b.__lit = true;
      } else if (b.__lit) {
        b.style.setProperty('--bglow', '0');
        b.__lit = false;
      }
    }
  }

  function spawn(x, y) {
    for (var n = 0; n < 2 && particles.length < 46; n++) {
      var a = Math.random() * Math.PI * 2, d = Math.random() * 34;
      particles.push({
        x: x + Math.cos(a) * d, y: y + Math.sin(a) * d,
        vx: (Math.random() - 0.5) * 0.018, vy: -0.012 - Math.random() * 0.03,
        r: 0.7 + Math.random() * 1.5, age: 0, life: 650 + Math.random() * 650,
        ph: Math.random() * 6.28
      });
    }
  }

  function frame(t) {
    var dt = Math.min(48, t - last || 16); last = t;
    glow.x += (target.x - glow.x) * Math.min(1, dt * 0.014);
    glow.y += (target.y - glow.y) * Math.min(1, dt * 0.014);
    intensity += ((wantOn ? 1 : 0) - intensity) * Math.min(1, dt * 0.008);

    ctx.clearRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'lighter';

    if (intensity > 0.01) {
      var R = 260;
      var g = ctx.createRadialGradient(glow.x, glow.y, 0, glow.x, glow.y, R);
      var a = 0.2 * strength * intensity;
      g.addColorStop(0, rgba(a));
      g.addColorStop(0.45, rgba(a * 0.4));
      g.addColorStop(1, rgba(0));
      ctx.fillStyle = g;
      ctx.fillRect(glow.x - R, glow.y - R, R * 2, R * 2);
    }

    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.age += dt;
      if (p.age >= p.life) { particles.splice(i, 1); continue; }
      p.x += p.vx * dt; p.y += p.vy * dt;
      var k = p.age / p.life;
      var tw = 0.55 + 0.45 * Math.sin(p.ph + p.age * 0.012);
      var al = Math.sin(k * Math.PI) * tw * (0.35 + strength * 0.6);
      var s = p.r * 4;
      var pg = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, s);
      pg.addColorStop(0, 'rgba(255,250,235,' + al + ')');
      pg.addColorStop(0.35, rgba(al * 0.5));
      pg.addColorStop(1, rgba(0));
      ctx.fillStyle = pg;
      ctx.fillRect(p.x - s, p.y - s, s * 2, s * 2);
    }

    if (wantOn || intensity > 0.01 || particles.length) {
      window.requestAnimationFrame(frame);
    } else {
      running = false;
      ctx.clearRect(0, 0, w, h);
    }
  }

  function start() {
    if (!running) { running = true; last = 0; window.requestAnimationFrame(frame); }
  }

  window.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    target.x = e.clientX; target.y = e.clientY;
    if (!wantOn) { glow.x = target.x; glow.y = target.y; }
    wantOn = true;
    if (Math.hypot(target.x - lastSpawn.x, target.y - lastSpawn.y) > 14) {
      spawn(target.x, target.y);
      lastSpawn.x = target.x; lastSpawn.y = target.y;
    }
    if (!btnTick) { btnTick = true; window.requestAnimationFrame(lightButtons); }
    start();
  }, { passive: true });

  document.addEventListener('pointerleave', function () { wantOn = false; lightButtons(); start(); });
  document.documentElement.addEventListener('mouseleave', function () { wantOn = false; lightButtons(); start(); });
  window.addEventListener('resize', resize, { passive: true });
  document.addEventListener('shopify:section:load', collectButtons);

  resize();
  collectButtons();
})();
